export class quickPayModel {
  "consumerId" : string = "";
  "phoneNo": string = "";
  "paymentOpt" : string = "";
  "consumerOtp" : string = "";
  "reEnterCaptcha" : string = "";
}


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/quickpay/quickpay.model.ts